import RedirectScreen from './RedirectScreen';
import SuccessScreen  from './SuccessScreen' ;
import ErrorScreen    from './ErrorScreen'   ;

type typeShaparakProps = {
  RedirectScreen: typeof RedirectScreen;
  SuccessScreen : typeof SuccessScreen ;
  ErrorScreen   : typeof ErrorScreen   ;
}

const Shaparak: typeShaparakProps = {
  RedirectScreen,
  SuccessScreen ,
  ErrorScreen   ,
};

export default Shaparak;
